import '@redbubble/skeleton/lib/styles.css';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import FavouriteIcon from '@redbubble/favourite-icon';

import SignUpModal from '../SignUpModal';
import {
  withAddWorkToFavorites,
  withRemoveWorkFromFavorites
} from '../../containers/apollo/withToggleListFavorite';

import analyticsPayload from '../../lib/analytics';
import styles from './FavoriteButton.css';

// eslint-disable-next-line react/prefer-stateless-function
export class FavoriteButton extends Component {
  render() {
    const {
      favorited,
      size,
      index,
      id,
      imgUrl,
      addWorkToFavorites,
      removeWorkFromFavorites,
      isLoggedIn
    } = this.props;

    const handleClick = (e, triggerModal) => {
      e.preventDefault();
      e.stopPropagation();

      if (!isLoggedIn) {
        triggerModal(e);
        return;
      }

      if (favorited) {
        removeWorkFromFavorites(id);
      } else {
        addWorkToFavorites(id);
      }

      const newState = !favorited;
      const rank = Number.isInteger(index) ? index + 1 : undefined;

      this.props.logEvent({
        analytics: analyticsPayload.favorite({ newState, workId: id, rank })
      });
    };

    return (
      <SignUpModal
        imgUrl={imgUrl}
        trigger={({ onClick: triggerModal }) => (
          <button
            className={styles.heart}
            onClick={e => handleClick(e, triggerModal)}
          >
            <FavouriteIcon favourited={favorited} size={size} />
          </button>
        )}
      />
    );
  }
}

FavoriteButton.displayName = 'FavoriteButton';

const FavoriteToggle = compose(
  withAddWorkToFavorites,
  withRemoveWorkFromFavorites
)(FavoriteButton);

FavoriteToggle.propTypes = {
  size: PropTypes.string.isRequired,
  favorited: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  imgUrl: PropTypes.string.isRequired,
  addWorkToFavorites: PropTypes.func.isRequired,
  removeWorkFromFavorites: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired
};

FavoriteToggle.defaultProps = {};

FavoriteToggle.displayName = FavoriteButton.displayName;

export default FavoriteToggle;
